import { useCallback, useState } from "react";
import DraftEntriesHeader from "src/components/pages/Settings/Miscellaneous/DraftEntries/DraftEntriesHeader";
import DraftEntriesTable from "src/components/pages/Settings/Miscellaneous/DraftEntries/DraftEntriesTable";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

export interface IDraftEntry {
  datecreated: string;
  full_name: string;
  lbeid: string;
  meid?: string;
  partid?: string;
  id?: string;
  lbid: string;
  lbname: string;
  sect?: string;
  rolename: string;
  status: number;
  delby?: string;
  deldate?: string;
}

export interface ISelectedDraft {
  id?: string;
  lbeid?: string;
  partid?: string;
  meid?: string;
}

const DraftEntries = () => {
  const [deleted, setDeleted] = useState(false);
  const [selected, setSelected] = useState<ISelectedDraft[]>([]);

  const mapDraftEntries = useCallback((data: any): IDraftEntry[] => {
    setSelected([]);
    return data?.data ?? [];
  }, []);

  const { data, isLoading, refetch } = useGetApi({
    request: deleted ? "get-delete-drafts" : "get-drafts",
    mapper: mapDraftEntries,
  });

  const handleStatusChange = useCallback((value: string) => {
    setDeleted(value === "deleted");
  }, []);

  const handleCheckAll = useCallback(() => {
    if (data && selected.length !== data?.length) {
      const list = deleted
        ? data.map(e => ({ id: e.id }))
        : data.map(e => ({ lbeid: e.lbeid, partid: e.partid, meid: e.meid }));
      setSelected(list);
    } else {
      setSelected([]);
    }
  }, [data, deleted, selected.length]);

  const handleSelect = useCallback(
    (row: IDraftEntry) => {
      let index: number | null = null;
      let item: ISelectedDraft = {};

      if (deleted) {
        item.id = row.id;
        index = selected.findIndex(e => e.id === item.id);
      } else {
        item = { lbeid: row.lbeid };
        if (row.partid) item.partid = row.partid;
        if (row.meid) item.meid = row.meid;
        index = selected.findIndex(e =>
          item.meid
            ? e.meid === item.meid
            : item.partid
              ? e.partid === item.partid
              : e.lbeid === item.lbeid,
        );
      }

      if (typeof index === "number") {
        if (index === -1) {
          setSelected([...selected, item]);
        } else {
          const updated = [...selected];
          updated.splice(index, 1);
          setSelected(updated);
        }
      }
    },
    [deleted, selected],
  );

  return (
    <PageContainer>
      <DraftEntriesHeader
        deleted={deleted}
        onStatusChange={handleStatusChange}
        onCheckAll={handleCheckAll}
        selected={selected}
        refetch={refetch}
      />
      <DraftEntriesTable
        data={data ?? []}
        loading={isLoading}
        selected={selected}
        handleSelect={handleSelect}
        deleted={deleted}
      />
    </PageContainer>
  );
};

export default DraftEntries;
